import { UserInfoState } from './user-info.state';
import { UserActionsUnion, UserActionTypes } from './user-info.actions';

export const userInitialState: UserInfoState = {
  payload: {
    user: null,
  },
  loading: false,
  error: null
};

export function userInfoReducer(state = userInitialState, action: UserActionsUnion): UserInfoState {
  switch (action.type) {
    case UserActionTypes.LOAD_USER_INFO:
      return {
        ...state,
        loading: true
      };

    case UserActionTypes.LOAD_USER_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        payload: {
          user: action.payload.user
        }
      };

    case UserActionTypes.LOAD_USER_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };

    case UserActionTypes.USER_LOGOUT:
      return {
        payload: {
          user: null
        },
        loading: false,
        error: null
      };

    default:
      return state;
  }
}
